import { HERO_ICONS } from "@components/atoms/Icons"
import { cn } from "@utils/tw"

export const Select = ({
  label,
  placeholder,
  options,
  value,
  onChange,
  className,
  innerClassName,
}: {
  label?: string
  placeholder?: string
  options: { value?: string; label: string }[]
  value?: string
  onChange?: (value: any) => void
  className?: string
  innerClassName?: string
}) => {
  const allOptions = placeholder ? [{ value: "", label: placeholder }, ...options] : options

  return (
    <div className={cn("flex flex-col gap-1 relative text-grey-2 shrink-0", className)}>
      {label && (
        <label className="type-body-s" htmlFor={label}>
          {label}
        </label>
      )}
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          className={cn(
            "!w-full !border !border-current !rounded-md !type-ui-label !text-[16px] !h-buttonLg md:!h-7 !pl-4 !mr-7 md:!mr-6 !appearance-none !bg-none bg-transparent",
            innerClassName,
          )}
        >
          {allOptions.map((option, ox) => (
            <option key={`${option.value}${ox}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute right-2 top-1/2 -translate-y-1/2 w-[1.4em] h-[1.4em] pointer-events-none">
          {HERO_ICONS["chevron-down"]}
        </div>
      </div>
    </div>
  )
}
